module.exports = __webpack_public_path__ + "img/abc_news.b6a1a514.png";